import React from 'react';
import ReactTooltip from 'react-tooltip';
import {
  Col, Button, FormGroup, Label, Input
} from 'reactstrap';

const isJsonString = (str) => {
  if (typeof str !== 'string') {
    console.log('Not a string');
    return false;
  }

  if (str.indexOf('{') < 0) {
    console.log('Missing opening bracket');
    return false;
  }

  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    console.log('Bad JSON');
    return false;
  }
};

export default function Thresholds({ value = '[{}]', updateThresholds }) {
  let thresholds = [];

  if (!isJsonString(value)) {
    return (<span>Cannot Parse Thresholds!</span>);
  }

  if (Array.isArray(JSON.parse(value))) {
    thresholds = JSON.parse(value).filter((t) => Object.prototype.hasOwnProperty.call(t, 'maxThreshold')
      && Object.prototype.hasOwnProperty.call(t, 'minThreshold')
      && Object.prototype.hasOwnProperty.call(t, 'level'));
  }

  const appendThreshold = () => {
    thresholds.push({ minThreshold: null, maxThreshold: null, level: 'none' });
    updateThresholds(JSON.stringify(thresholds));
  };
  const removeThreshold = (idx) => {
    thresholds.splice(idx, 1);
    if (thresholds.length <= 0) {
      thresholds = '[{}]';
    }
    updateThresholds(JSON.stringify(thresholds));
  };
  const updateThreshold = (idx, newValue) => {
    thresholds[idx] = newValue;
    updateThresholds(JSON.stringify(thresholds));
  };
  return (
    <div>
      <FormGroup row>
        <Col md='6'>
          <Label htmlFor='thresholds'>Thresholds</Label>
        </Col>
        <Col md='6'>
          <Button onClick={appendThreshold} color='primary' className='btn-right'>
            <i className='fa fa-plus-circle' />
            {' Add Threshold'}
          </Button>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Col xs='12' md='12'>
          {thresholds.map((t, i) => (
            <Threshold
              key={`th${i}`}
              threshold={t}
              index={i}
              removeThreshold={removeThreshold}
              updateThreshold={updateThreshold}
            />
          ))}
        </Col>
      </FormGroup>
    </div>
  );
}

function Threshold({
  threshold, index, removeThreshold, updateThreshold
}) {
  const handleInputChange = (event) => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    // eslint-disable-next-line no-restricted-globals
    updateThreshold(index, { ...threshold, [name]: (name !== 'level' && isNaN(value) ? null : value) });
  };
  return (
    <FormGroup row key={threshold}>
      <Col md='2' className='text-right mt-1'>
        <Label htmlFor='minThreshold'>Min</Label>
      </Col>
      <Col md='2'>
        <Input
          type='text'
          name='minThreshold'
          id='minThreshold'
          onChange={handleInputChange}
          placeholder='-'
          value={threshold.minThreshold || ''}
        />
      </Col>
      <Col md='1' className='text-right mt-1'>
        <Label htmlFor='maxThreshold'>Max</Label>
      </Col>
      <Col md='2'>
        <Input
          type='text'
          name='maxThreshold'
          id='maxThreshold'
          onChange={handleInputChange}
          placeholder='-'
          value={threshold.maxThreshold || ''}
        />
      </Col>
      <Col md='1' className='text-right mt-1'>
        <Label htmlFor='level'>Level</Label>
      </Col>
      <Col md='3'>
        <Input type='select' name='level' id='level' onChange={handleInputChange} value={threshold.level || 'none'}>
          <option key='none' value='none'>None</option>
          <option key='good' value='good'>Good</option>
          <option key='warn' value='warn'>Warn</option>
          <option key='bad' value='bad'>Bad</option>
        </Input>
      </Col>
      <Col md='1'>
        <span
          className='btn btn-primary btn-circle mt-1'
          onClick={() => removeThreshold(index)}
          data-tip='Remove'
        >
          <i className='fa fa-times' />
        </span>
        <ReactTooltip />
      </Col>
    </FormGroup>
  );
}
